import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import CrisisResourceBanner from '../../components/CrisisResourceBanner';
import Button from '../../components/ui/Button';
import AvailabilityManager from './components/AvailabilityManager';
import ExpertiseManager from './components/ExpertiseManager';
import CredentialVerification from './components/CredentialVerification';
import PerformanceAnalytics from './components/PerformanceAnalytics';
import ProfileCustomization from './components/ProfileCustomization';
import TabNavigation from './components/TabNavigation';
import HelperResourcesPanel from './components/HelperResourcesPanel';

const HelperProfileManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('profile');

  // Get helperId from navigation state (if editing existing helper)
  const helperId = location?.state?.helperId || null;
  const isAddMode = !helperId; // If no helperId, we're adding a new helper

  const tabs = [
    { id: 'profile', label: 'Profile', icon: 'User' },
    { id: 'availability', label: 'Availability', icon: 'Calendar' },
    { id: 'expertise', label: 'Expertise', icon: 'Brain' },
    { id: 'credentials', label: 'Credentials', icon: 'Shield' },
    { id: 'analytics', label: 'Analytics', icon: 'TrendingUp' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'availability':
        return <AvailabilityManager />;
      case 'expertise':
        return <ExpertiseManager />;
      case 'credentials':
        return <CredentialVerification />;
      case 'analytics':
        return <PerformanceAnalytics />;
      case 'profile':
        return <ProfileCustomization helperId={helperId} isAddMode={isAddMode} />;
      default:
        return <AvailabilityManager />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <CrisisResourceBanner />
      <Header />
      <main className="pt-32 pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">Helper Profile Management</h1>
              <p className="text-muted-foreground">
                Manage your availability, expertise, and credentials to help seekers find the right support
              </p>
            </div>
            <Button
              variant="outline"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={() => navigate('/personal-dashboard')}
            >
              Back to Dashboard
            </Button>
          </div>

          <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

          <div className="mb-6">
            {renderTabContent()}
          </div>

          <HelperResourcesPanel />
        </div>
      </main>
    </div>
  );
};

export default HelperProfileManagement;